import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";
import { ResponseUtils } from '../response-utils';

export const kymw1318Handlers = [
  // 選定解除対象情報取得 /kymw13/getDeletePlanGoodsInfo
  http.post(PlessService.SERVICE.getDeletePlanGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getDeletePlanGoodsInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定解除企画商品情報削除 /kymw13/deletePlanGoodsInfo
  http.post(PlessService.SERVICE.deletePlanGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.getE0540();
  }),
];

const getDeletePlanGoodsInfoResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      OrderCodeList: [
        "2024060",
        "2024010"
      ],
      DeletePlanGoodsTargetList: [
        {
          OrderCode: "2024020",
          MediumType: "001",
          MediumName: "ハピデリ",
          ConfirmedFlg: "1"
        },
        {
          OrderCode: "2024020",
          MediumType: "003",
          MediumName: "ぐるめぐり",
          ConfirmedFlg: "0"
        },
        {
          OrderCode: "2024030",
          MediumType: "001",
          MediumName: "ハピデリ",
          ConfirmedFlg: "0"
        },
        {
          OrderCode: "2024040",
          MediumType: "003",
          MediumName: "ぐるめぐり",
          ConfirmedFlg: "0"
        },
        {
          OrderCode: "2024010",
          MediumType: "001",
          MediumName: "ハピデリ",
          ConfirmedFlg: "1"
        },
        {
          OrderCode: "2024010",
          MediumType: "003",
          MediumName: "ぐるめぐり",
          ConfirmedFlg: "0"
        },
        {
          OrderCode: "2024010",
          MediumType: "150",
          MediumName: "予約チラシ",
          ConfirmedFlg: "1"
        },
        {
          OrderCode: "2024050",
          MediumType: "023",
          MediumName: "コスメｄｅきれい（ＣＤ）",
          ConfirmedFlg: "1"
        },
      ],
    }
  }   
};
